module.exports = __webpack_public_path__ + "img/logo-login.6d10712d.png";